module.exports = __webpack_public_path__ + "static/media/kawaii-popcorn.acb977ae.svg";